import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {TheCrypt} from "../TheCrypt";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {gsap} from "gsap";
import {TheCryptWinConfig} from "../configs/TheCryptWinConfig";
import {TheCryptHelper} from "../utils/TheCryptHelper";

export class WinCountUpPresentation implements SimplePresentation {
    constructor() {
    }

    shouldRun(): boolean {
        return !TheCrypt.model.brokeTheBank && !TheCrypt.model.isBigWin && TheCrypt.model.isWin;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline();
        const isWinBelowStake: boolean = TheCryptHelper.isWinBelowStake();
        tl.add(() => controller.setSkipCallback(() => {
            tl.timeScale(2);
        }));

        // #46 Fixes
        if (!isWinBelowStake) {
            tl.add(TheCrypt.totalWinView.show(TheCryptWinConfig.getWinConfig()));
            tl.to(this, {duration: 0.01});
            tl.add(() => controller.finish(), "-=1");
        } else {
            tl.add(() => {
                TheCrypt.keypadPlugin.setWin(TheCrypt.model.gameData.accumulatedRoundWin, true, isWinBelowStake);
                controller.finish();
            });
        }

        if (TheCrypt.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            tl.timeScale(1.4);
        }

    }
}
